import { cn } from '@/lib/utils';

import Card, { CardProps } from '@/components/atoms/Card';

import { darkCardRoot } from '../consts';

type BentoDarkCardProps = {
  children: React.ReactNode;
  className?: string;
  roudnessLevel?: CardProps['roudnessLevel'];
  padSize?: CardProps['padSize'];
};

// shared dark shell for review + award cards in the bento awards slice
export function BentoDarkCard({
  children,
  className,
  roudnessLevel = 'l',
  padSize = 'm',
}: BentoDarkCardProps) {
  return (
    <Card
      roudnessLevel={roudnessLevel}
      padSize={padSize}
      hasShadow
      classNames={{
        root: cn(darkCardRoot, className),
      }}
    >
      {children}
    </Card>
  );
}
